module.exports = __webpack_public_path__ + "static/media/home_musical_cover.378be72e.jpg";